import IconDown from 'assets/supplier/circle-icon-down.inline.svg';
import IconButton from 'components/base/IconButton';
import Footer from 'components/Footer';
import { StoreSection } from 'components/FooterLP';
import Layout from 'components/Layout';
import FAQuestions from 'components/pages/pricing/view/FAQuestions';
import { FormProvider } from 'components/pages/promotional/budma/base/FormContext';
import ApplyView from 'components/pages/promotional/budma/view/ApplyView';
import CarouselList from 'components/pages/supplier/base/CarouselList';
import BenefitItem from 'components/pages/supplier/items/BenefitItem';
import { ENUM_FAQ_CATEGORY, ENUM_PAGE, ENUM_SOURCE } from 'constants/enums';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useClientInfo from 'hooks/useClientInfo';
import React, { useRef } from 'react';
import { isMobileScreen, scrollInto } from 'utils/helper';

export default function SupplierPage() {
	const { t } = useTranslation();
	const { client } = useClientInfo(ENUM_PAGE.FINTEQ, ENUM_SOURCE.SUPPLIER_FORM);
	const refApplyView = useRef();
	const isMobile = isMobileScreen();

	const handleRefToApplyView = () => {
		scrollInto(refApplyView);
	};

	return (
		<Layout>
			<div className='mb-40'>
				{/* discount your invoice */}
				<div className='sm:flex sm:items-center xl:items-start justify-end'>
					<div className='w-full sm:w-50/100 mt-10 sm:ml-30'>
						<div className='layout sm:mr-20'>
							<h1 className='sm:text-shadow pt-40 sm:pt-60 lg:pt-80 xl:pt-120'>{t('pageSupplier.h1')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h1>
							<p className='font-bold'>{t('pageSupplier.desc.bold.1')}</p>
							<p className='font-bold'>
								{t('pageSupplier.desc.bold.2')}
								<span className='text-green-1'>{t('pageSupplier.desc.bold.3')}</span>
							</p>
							<p className='my-15'>
								{t('pageSupplier.desc.1')}
								<span className='text-green-1'>{t('pageSupplier.desc.2')}</span>
								{t('pageSupplier.desc.3')}
							</p>
							{!isMobile && (
								<ul className='ul-custom-triangle'>
									<li className='text-10 leading-10'>{t('pageSupplier.desc.li.1')}</li>
									<li className='text-10 leading-10'>{t('pageSupplier.desc.li.2')}</li>
									<li className='text-10 leading-10'>{t('pageSupplier.desc.li.3')}</li>
								</ul>
							)}
						</div>
					</div>

					<div className='hidden sm:block sm:w-50/100'>
						<StaticImage src='../../../assets/supplier/discount-your-invoice.png' alt="" placeholder='none' />
					</div>

					<div className='sm:hidden w-full my-15'>
						<StaticImage src='../../../assets/supplier/mobile-discount-your-invoice.png' alt="" placeholder='none' />
					</div>
				</div>

				{isMobile && (
					<ul className='layout ul-custom-triangle'>
						<li className='text-10 leading-10'>{t('pageSupplier.desc.li.1')}</li>
						<li className='text-10 leading-10'>{t('pageSupplier.desc.li.2')}</li>
						<li className='text-10 leading-10'>{t('pageSupplier.desc.li.3')}</li>
					</ul>
				)}

				{/*cash on demand*/}
				<div className='sm:flex sm:items-center sm:flex-row-reverse justify-start mt-40'>
					<div className='w-full sm:w-50/100 mt-10 mb-20 sm:mb-60 sm:mr-20'>
						<div className='layout sm:ml-20 sm:text-right'>
							<div className='xl:w-80/100 ml-auto'>
								<h2 className='mb-24'>{t('pageSupplier.cashDemands.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
								<p className='font-bold'>
									{t('pageSupplier.cashDemands.desc.bold.1')}
									<span className='text-green-1'>{t('pageSupplier.cashDemands.desc.bold.2')}</span>
									{t('pageSupplier.cashDemands.desc.bold.3')}
								</p>
								<p className='my-15'>{t('pageSupplier.cashDemands.desc.1')}</p>
								<p className='mb-20'>{t('pageSupplier.cashDemands.desc.2')}</p>
							</div>
						</div>
					</div>
					<div className='hidden sm:block sm:w-50/100'>
						<StaticImage src='../../../assets/supplier/cash-on-demand.png' alt="" placeholder='none' />
					</div>
					<div className='sm:hidden'>
						<StaticImage src='../../../assets/supplier/mobile-cash-on-demand.png' alt="" placeholder='none' />
					</div>
				</div>

				{/*account for zero*/}
				<div className='sm:flex sm:items-center justify-start -mt-20 sm:mt-40'>
					<div className='w-full sm:w-50/100 mt-10 sm:ml-30'>
						<div className='layout sm:mr-20 sm:text-left'>
							<div className='w-full ml-auto'>
								<h2 className='mb-24'>{t('pageSupplier.accountForZero.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
								<p className='font-bold'>
									{t('pageSupplier.accountForZero.desc.bold.1')}
									<span className='text-green-1'>{t('pageSupplier.accountForZero.desc.bold.2')}</span>
								</p>
								<p className='my-15'>{t('pageSupplier.accountForZero.desc.1')}</p>
								<p className='font-bold'>
									{t('pageSupplier.accountForZero.desc.bold.3')}
								</p>
								<StoreSection tw='flex items-center justify-start mt-05' />
							</div>
						</div>
					</div>
					<div className='hidden sm:block sm:w-50/100'>
						<StaticImage src='../../../assets/supplier/account-for-zero.png' alt="" placeholder='none' />
					</div>
					<div className='sm:hidden mt-30'>
						<StaticImage src='../../../assets/supplier/mobile-account-for-zero.png' alt="" placeholder='none' />
					</div>
				</div>

				{/* one fee */}
				<div className='sm:flex sm:items-center justify-start mt-40'>
					<div className='hidden sm:block sm:w-50/100'>
						<StaticImage src='../../../assets/supplier/one-fee.png' alt="" placeholder='none' />
					</div>
					<div className='w-full sm:w-50/100 mt-10 mb-30 sm:mb-60 sm:mr-20'>
						<div className='layout sm:ml-20 sm:text-right'>
							<div className='xl:w-80/100 ml-auto'>
								<h2 className='mb-24'>{t('pageSupplier.onePayment.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
								<p className='font-bold'>
									{t('pageSupplier.onePayment.desc.bold.1')}
									<span className='text-green-1'>{t('pageSupplier.onePayment.desc.bold.2')}</span>
								</p>
								<p className='my-15'>{t('pageSupplier.onePayment.desc.1')}</p>
							</div>
						</div>
					</div>
					<div className='sm:hidden'>
						<StaticImage src='../../../assets/supplier/mobile-one-fee.png' alt="" placeholder='none' />
					</div>
				</div>

				{/* no papers */}
				<div className='sm:flex sm:items-center justify-end mt-40 relative bg-grey-F border-t-3 border-b-3 border-solid border-grey-E text-center py-35 mt-20 sm:mt-50 2xl:mt-80'>
					{/*<div className='absolute hidden xl:block right-0 -mt-80 z-0'></div>*/}
					<div className='w-full sm:w-50/100 mt-10 sm:ml-30'>
						<div className='layout sm:mr-20 text-left'>
							<div className='w-full ml-auto'>
								<h2 className='mb-24'>{t('pageSupplier.noPapers.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
								<p className='font-bold'>
									{t('pageSupplier.noPapers.desc.bold.1')}
									<span className='text-green-1'>{t('pageSupplier.noPapers.desc.bold.2')}</span>
								</p>
								<p className='my-15'>
									{t('pageSupplier.noPapers.desc.1')}

									<ul className='ul-outline-triangle mt-10'>
										<li>{t('pageSupplier.noPapers.desc.li.1')}</li>
										<li>{t('pageSupplier.noPapers.desc.li.2')}</li>
										<li>{t('pageSupplier.noPapers.desc.li.3')}</li>
									</ul>
								</p>
							</div>
						</div>
					</div>
					<div className='sm:w-50/100'>
						<StaticImage src='../../../assets/supplier/without-papers.png' alt="" placeholder='none' />
					</div>
				</div>

				{/*no risk*/}
				<div className='sm:flex sm:items-center sm:flex-row-reverse justify-start mt-40'>
					<div className='w-full sm:w-50/100 mt-10 mb-30 sm:mb-60 sm:mr-20'>
						<div className='layout sm:ml-20 sm:text-right'>
							<div className='xl:w-80/100 ml-auto'>
								<h2 className='mb-24'>{t('pageSupplier.noRisk.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
								<p className='font-bold'>
									{t('pageSupplier.noRisk.desc.bold.1')}
									<span className='text-green-1'>{t('pageSupplier.noRisk.desc.bold.2')}</span>
								</p>
								<p className='my-15'>{t('pageSupplier.noRisk.desc.1')}</p>
								<p>
									{t('pageSupplier.noRisk.desc.2')}
									<span className='text-green-1'>{t('pageSupplier.noRisk.desc.3')}</span>
								</p>
								<p>{t('pageSupplier.noRisk.desc.4')}</p>
							</div>
						</div>
					</div>
					<div className='sm:w-50/100 lg:-mr-100 2xl:-mr-200 -z-10'>
						<StaticImage src='../../../assets/supplier/without-risk.png' alt="" placeholder='none' />
					</div>
				</div>

				{/* security */}
				<div className='sm:flex sm:items-center justify-start mt-40 relative bg-grey-F border-t-3 border-b-3 border-solid border-grey-E text-center py-35 mt-20 sm:mt-50'>
					<div className='w-full sm:w-50/100 mt-10 sm:ml-30'>
						<div className='layout sm:mr-20 text-left'>
							<div className='w-full ml-auto'>
								<h2 className='mb-24'>{t('pageSupplier.security.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
								<p className='font-bold'>
									{t('pageSupplier.security.desc.bold')}
								</p>
								<p className='my-15'>
									{t('pageSupplier.security.desc.1')}
								</p>
								<StaticImage src='../../../assets/supplier/security-rodo-psd2.png' alt="" placeholder='none' />
							</div>
						</div>
					</div>
					<div className='hidden sm:block sm:w-50/100'>
						<StaticImage src='../../../assets/supplier/security.png' alt="" placeholder='none' />
					</div>
					<div className='sm:hidden mt-20'>
						<StaticImage src='../../../assets/supplier/mobile-security.png' alt="" placeholder='none' />
					</div>
				</div>

				<div className='layout text-center'>
					<h2 className='pt-40 sm:pt-60 lg:pt-80 xl:pt-120 mb-40 sm:mb-40'>{t('pageSupplier.benefits.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
					{!isMobile && <p className='layout font-bold mt-24 sm:mb-40'>{t('pageSupplier.benefits.desc')}</p>}

					<div className='grid xl:grid-cols-2 2xl:grid-cols-4 gap-x-05 xl:gap-x-120 gap-y-10 sm:gap-y-15 items-center justify-center'>
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.1')} Image={<div tw='-mt-11'><StaticImage src='../../../assets/supplier/benefits/account-for-0.png' alt='account-for-0' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.2')} Image={<div tw='-ml-12 xl:-ml-24'><StaticImage src='../../../assets/supplier/benefits/money-on-demand.png' alt='money-on-demand' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.3')} Image={<div tw='-mt-07 -ml-07'><StaticImage src='../../../assets/supplier/benefits/no-papers.png' alt='no-papers' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.4')} Image={<div tw='mt-07'><StaticImage src='../../../assets/supplier/benefits/no-security.png' alt='no-security' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.5')} Image={<div tw='mt-03'><StaticImage src='../../../assets/supplier/benefits/one-payment.png' alt='one-payment' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.6')} Image={<div tw='-ml-20 xl:-ml-30'><StaticImage src='../../../assets/supplier/benefits/security.png' alt='security' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.7')} Image={<div tw='mt-03 -ml-15 xl:-ml-24'><StaticImage src='../../../assets/supplier/benefits/no-use-no-pay.png' alt='no-use-no-pay' /></div>} />
						<BenefitItem isMobile={isMobile} title={t('pageSupplier.benefits.li.8')} Image={<div><StaticImage src='../../../assets/supplier/benefits/no-suprises.png' alt='no-suprises' /></div>} />
					</div>
				</div>

				<div className='text-center'>
					<h2 className='pt-40 sm:pt-60 lg:pt-80 mb-40'>{t('pageSupplier.howItWork.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
					<div className='sm:hidden'>
						<CarouselList />
					</div>

					<div className='hidden sm:flex layout h-90 items-center justify-center text-left'>
						<div className='w-full h-full border border-grey-E rounded-10'>
							<div className='relative rounded-10 px-10 py-10'>
								<div className='text-green-1 font-bold absolute top-0 bg-light h-15 -mt-07 w-85 text-center'>{t('pageSupplier.howItWork.title.1')}</div>
								<div>{t('pageSupplier.howItWork.desc.1')}</div>
							</div>
						</div>
						<IconButton className='mx-10' onClick={handleRefToApplyView}>
							<IconDown />
						</IconButton>
						<div className='w-full h-full border border-grey-E rounded-10'>
							<div className='relative rounded-10 px-10 py-10'>
								<div className='text-green-1 font-bold absolute top-0 bg-light h-15 -mt-07 w-70 text-center'>{t('pageSupplier.howItWork.title.2')}</div>
								<div>{t('pageSupplier.howItWork.desc.2')}</div>
							</div>
						</div>
					</div>
				</div>

				<FormProvider>
					<ApplyView
						refForward={refApplyView}
						client={client}
						applyTitle={t('pageSupplier.applyClient.h2')}
						applyDesc1={t('pageSupplier.applyClient.desc')}
						marketingConsent={t('app.marketingConsent')}
					/>
				</FormProvider>

				<h2 className='text-center mt-60 mb-50'>{t('pageSupplier.faq.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
				<FAQuestions category={ENUM_FAQ_CATEGORY.SUPPLIER_PAGE} />
			</div>

			<div className='relative pb-100'>
				<div className='xl:hidden absolute right-0 bottom-0'>
					<StaticImage src='../../../assets/supplier/mobile-faq.png' alt="" placeholder='none' />
				</div>
				<div className='hidden xl:block absolute right-0 bottom-0 -z-10'>
					<StaticImage src='../../../assets/supplier/faq.png' alt="" placeholder='none' />
				</div>
			</div>
			<Footer />
		</Layout>
	);
}
